import { notification } from 'antd'
import { makeAutoObservable } from 'mobx'

import { ordersApi } from '../../../api'
import { OrderCCTVModel } from './OrderCCTVModel'

export class OrderCCTVApiStore {
  constructor(protected readonly model: OrderCCTVModel) {
    makeAutoObservable(this)
  }

  async validateCCTVInfo(pvzId: number) {
    if (!this.model.vendorValue) {
      return
    }

    try {
      const res = await ordersApi.validateCCTVInfo({
        externalPickPointId: pvzId,
        vendor: this.model.vendorValue,
        url: this.model.url.trim(),
        login: this.model.login.trim(),
        password: this.model.password,
        token: this.model.token,
        description: this.model.description.trim(),
      })

      this.model.setValidateCCTVResult(res)

      if (!res.isValidated) {
        notification.error({
          message: 'Ошибка валидации',
          description: 'Для успешной валидации нужно произвести настройки в видеосервисе согласно инструкции',
        })

        return false
      }

      if (!res.cameraCheck) {
        notification.error({
          message: 'Количество переданных камер меньше 3',
        })
      }

      if (!res.statusCheck) {
        notification.error({
          message: 'Имеются выключенные камеры',
        })
      }

      if (!res.archiveCheck) {
        notification.error({
          message: 'Имеются камеры с нарушениями по глубине хранения видео архива',
        })
      }

      if (!res.archiveCheck || !res.cameraCheck || !res.statusCheck) {
        return false
      }

      return true
    } catch (error) {
      return true
    }
  }

  async addCCTVInfo(orderId: number) {
    try {
      await ordersApi.addCCTVInfo({
        orderId,
        url: this.model.url.trim(),
        login: this.model.login.trim(),
        password: this.model.password,
        description: this.model.description.trim(),
      })
    } catch (error) {
      throw new Error(`Не удалось сохранить данные о видеонаблюдении. ${(error as Error).message}`)
    }
  }

  async getVendorList() {
    try {
      const res = await ordersApi.getVendorList()
      this.model.setVendorList(res)
    } catch (error) {
      throw new Error(`Не удалось получить список поставщиков. ${(error as Error).message}`)
    }
  }

  async getCCTVInfo(orderId: number) {
    try {
      const result = await ordersApi.getCCTVInfo(orderId)

      if (result) {
        this.model.initCCTVInfo(result)
      }
    } catch (error) {
      notification.error({ message: `Не удалось получить данные о видеонаблюдении. ${(error as Error).message}` })
    }
  }
}
